export default "__VITE_ASSET__CbDjCXpT__"